import React from "react";
import logoSrc from '../img/logo.png';
import './Investments.css';

function InvestOnMVP() {
  return (
    <>
   
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section">
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">invest on MVPs</h1>
            <p className="banner-description">
              Focus on developing a minimal viable product (MVP) to validate your idea in the market and secure future growth opportunities.
            </p>
            <a href="/invest-mvp" className="banner-button">
              Start Your MVP Journey
            </a>
          </div>
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Invest in MVPThumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>
      {/* About Section */}
      <section className="about-section">
        {/* Section 1 */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Why Invest in an MVP?</strong></h2>
            <p>
              A well-built MVP helps businesses validate concepts quickly, saving both time and money. Start small, test your idea, and scale up.
            </p>
            <ul>
              <li><strong>Quick Testing:</strong> Test your product in the market fast.</li>
              <li><strong>Risk Reduction:</strong> Minimize risks by validating your concept early.</li>
              <li><strong>Cost Efficiency:</strong> Avoid unnecessary expenditures.</li>
            </ul>
            <button className="cta-button">Start Building Your MVP</button>
          </div>
          <div className="about-image">
            <img src="mvp-development.jpg" alt="MVP Development" />
          </div>
        </div>
      </section>
    </>
  );
}

export default InvestOnMVP;
